<div
  class="stat-card"
  [class.stat-card--stacked]="layout() === 'stacked'"
  [class.stat-card--lg]="size() === 'lg'"
>
  <span class="stat-card__value" [class.\!text-body-2xl]="size() === 'lg'">{{ value() }}</span>

  <div class="stat-card__text">
    <span class="stat-card__label">{{ label() }}</span>

    @if (layout() === 'row') {
      @if (delta()) {
        <div class="flex items-center gap-1">
          <mat-icon
            class="!text-sm"
            [class.stat-card__delta--good]="isDeltaGood"
            [class.stat-card__delta--bad]="!isDeltaGood"
          >
            {{ isDeltaUp ? 'arrow_upward' : 'arrow_downward' }}
          </mat-icon>
          <span
            class="stat-card__delta"
            [class.stat-card__delta--good]="isDeltaGood"
            [class.stat-card__delta--bad]="!isDeltaGood"
            >{{ delta() }}</span
          >
          @if (deltaLabel()) {
            <span class="stat-card__delta-label">{{ deltaLabel() }}</span>
          }
        </div>
      } @else if (secondary()) {
        <span class="stat-card__delta-label">{{ secondary() }}</span>
      }
    }
  </div>
</div>
